import { render, staticRenderFns } from "./EDadoDoAluno.vue?vue&type=template&id=49cb84db"
import script from "./EDadoDoAluno.vue?vue&type=script&lang=js"
export * from "./EDadoDoAluno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports